<template>
  <CxCardContainer class="design-system">
    <template #body>
      <InCardLoader v-if="isLoadingImports && imports.length == 0" :loadingMessage="translate('SHARED.LOADING')" />
      <CxTable v-if="imports.length > 0">
        <CxTr>
          <CxTh>{{ translate("CATALOG_IMPORTS.DATE") }}</CxTh>
          <CxTh>{{ translate("CATALOG_IMPORTS.SOURCE") }}</CxTh>
          <CxTh>{{ translate("CATALOG_IMPORTS.DESTINATION") }}</CxTh>
          <CxTh>{{ translate("CATALOG_IMPORTS.DATA") }}</CxTh>
          <CxTh>{{ translate("CATALOG_IMPORTS.STATUS") }}</CxTh>
          <CxHeaderActions>
            {{ translate("CATALOG_IMPORTS.ACTIONS") }}
          </CxHeaderActions>
        </CxTr>
        <ImportsRow v-for="importRow in imports" :key="importRow.id" :importRow="importRow"></ImportsRow>
      </CxTable>
      <CxRow v-if="!isLoadingImports && imports.length == 0">
        <CxCol>
          <CxText>{{ translate("CATALOG_IMPORTS.NO_IMPORT") }}</CxText>
        </CxCol>
      </CxRow>
      <CxRow v-if="hasMoreRows">
        <CxCol display="flex" justify-content="center" class="mt-5">
          <CxButton variant="link" @click="getImports()" :is-loading="isLoadingImports">
            {{ translate("CATALOG_IMPORTS.SHOW_MORE") }}
            <CxIcon icon="stat_minus_1"></CxIcon>
          </CxButton>
        </CxCol>
      </CxRow>
    </template>
  </CxCardContainer>
</template>

<script setup lang="ts">
/* eslint no-unused-vars:off */
import { onMounted, ref } from "vue";
import InCardLoader from "@/view/components/Shared/InCardLoader.vue";
import { listImports } from "@/apps/dashboard/catalog/core/infrastructure/repository/importRepository";
import { useRoute } from "vue-router";
import useTranslate from "@/core/composables/translate";
import useBreadcrumbStore from "@/core/store/config/breadcrumbsStore";
import { CxHeaderActions, CxTable, CxTh, CxTr } from "@/designSystem/Table";
import organizationService from "@/core/services/api/organization.service";
import { Organization } from "@/core/models/organization";
import { CxCardContainer, CxCol, CxRow } from "@/designSystem/Grid";
import ImportsRow from "@/apps/dashboard/catalog/view/components/Import/ImportsRow.vue";
import { Import } from "@/apps/dashboard/catalog/core/domain/Import";
import { CxText } from "@/designSystem/Typography";
import { CxButton, CxIcon } from "@/designSystem";

const route = useRoute();
const breadcrumbStore = useBreadcrumbStore();
const { translate } = useTranslate();

const account = ref<Organization | null>(null);

const imports = ref<Array<Import>>([]);

const isLoadingImports = ref(true);
const currentPage = ref(1);
const hasMoreRows = ref(false);

const getImports = async () => {
  isLoadingImports.value = true;

  try {
    const { results, pagination } = await listImports(route.params.accountId, currentPage.value);
    imports.value.push(...results);
    hasMoreRows.value = currentPage.value < pagination.total_pages;
    currentPage.value += 1;
  } finally {
    isLoadingImports.value = false;
  }
};

onMounted(async () => {
  account.value = await organizationService.fetchOrganizationById(route.params.accountId);

  getImports();

  breadcrumbStore.setBreadcrumb([
    {
      title: translate("MENU.DASHBOARD"),
    },
    {
      title: translate("MENU.CLIENTS"),
    },
    {
      title: account.value?.commonName,
    },
    {
      title: translate("CATALOG_IMPORTS.BREADCRUMB.IMPORTS"),
    },
  ]);
});
</script>
